
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonRefresher,
  IonRefresherContent,
  IonLabel,
  IonAvatar,
  IonRow,
  IonCol,
  // IonImg,
  IonCard,
  IonIcon,
  IonList,
  IonItem,
} from '@ionic/vue';
import {
  radioButtonOnOutline
} from 'ionicons/icons';
import MatchesService from "@/api/matches/MatchesService";
import {useRouter} from "vue-router";
import {
  calendarOutline,
  checkmarkOutline,
  closeOutline,
  removeOutline,
} from 'ionicons/icons';
// import './home.scss'
import {computed, ref} from "vue";

export default {
  name: "Play.vue",
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonRefresher,
    IonRefresherContent,
    IonLabel,
    IonAvatar,
    IonRow,
    IonCol,
    // IonImg,
    IonCard,
    IonIcon,
    IonList,
    IonItem,
  },
  setup() {
    const router = useRouter();

    const currentUser = ref<any>(JSON.parse(localStorage.getItem('userData') || '{}'))

    const {
      fetchMatches,
      getCurrentMatches,
      userTotalcoins,
      userTotalmatches,
      resolveChallengerAvatar,
      matchResultResolver,
    } = MatchesService()
    fetchMatches()

    const matches = computed(() => getCurrentMatches() || [])
    const upcomingMatches = computed(() =>
        matches.value.filter(match => match.status !== 'done' && match.my_points == null),
    )
    const executedMatches = computed(() =>
        matches.value.filter(match => match.status === 'done' || match.my_points),
    )
    const hasUpcomingMatches = computed(() => upcomingMatches.value.length > 0)
    const hasExecutedMatches = computed(() => executedMatches.value.length > 0)

    const doRefresh = (event: any) => {
      fetchMatches()
      setTimeout(() => {
        if (event.target !== null) {
          event.target.complete();
        }
      }, 2000);
    }

    function openQuiz(match) {
      if (match.status === 'doing') {
        router.replace({name: 'quiz', params: {id: match.id}})
      }
    }

    return {
      currentUser,
      doRefresh,
      matches,
      upcomingMatches,
      executedMatches,
      hasUpcomingMatches,
      hasExecutedMatches,
      userTotalcoins,
      userTotalmatches,
      resolveChallengerAvatar,
      matchResultResolver,
      openQuiz,
      radioButtonOnOutline,
      calendarOutline,
      checkmarkOutline,
      closeOutline,
      removeOutline,
    }
  },
}
